import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBackOfficeCommentsTable extends Layout {
    sourceComments: DataSource;
    tableComments: Table;
}
